import { Type, optional } from "specified";
const getConfigResponse = Type.interface({
  scope: Type.string,
  maxFileSizeBytes: Type.number,
  maxFileNameLength: Type.number,
  allowedFileTypes: optional(Type.array(Type.string)),
  isRecaptchaTokenRequired: Type.boolean
});
const getUploadTokenResponse = Type.interface({
  scope: Type.string,
  token: Type.string
});
const sendFileResponse = Type.interface({
  scope: Type.string,
  storageId: Type.string,
  storageToken: Type.string
});
export {
  getConfigResponse,
  getUploadTokenResponse,
  sendFileResponse
};
//# sourceMappingURL=specs.js.map
